import { Stack } from "@mui/material";

import { ClientContent } from "../../../client-content/ClientContent";
import { useClientFileContext } from "../../../context/ClientFileContext";
import { ExpensePartnerSection } from "./components/expense-partner-section/ExpensePartnerSection";
import { ExpenseProofsSection } from "./components/expense-proofs-section/ExpenseProofsSection";
import { GeneralQuestionsSection } from "./components/general-questions-section/GeneralQuestionsSection";
import { RecurringObligationsSection } from "./components/recurring-obligations-section/RecurringObligationsSection";
import { useAssetExpenses } from "./hooks/useAssetExpenses";

const NO_MAINTENANCE = { personCount: 0, amount: 0 };

export function ExpensesView() {
  const { clientId, capabilities } = useClientFileContext();
  const {
    formik,
    maintenance,
    summary,
    missingFields,
    saveAttempted,
    livingCostsBelowMinimum,
    onAddMove,
    onCancelMove,
  } = useAssetExpenses(clientId);

  return (
    <ClientContent formik={formik} missingFields={missingFields}>
      <Stack gap={2}>
        <GeneralQuestionsSection formik={formik} />
        <RecurringObligationsSection
          formik={formik}
          maintenance={maintenance ?? NO_MAINTENANCE}
          summary={summary}
          saveAttempted={saveAttempted}
          livingCostsBelowMinimum={livingCostsBelowMinimum}
          partnerBlock={
            capabilities.counselorExpensePartner ? (
              <ExpensePartnerSection clientId={clientId} isDirty={formik.dirty} />
            ) : undefined
          }
        />
        <ExpenseProofsSection clientId={clientId} formik={formik} onAddMove={onAddMove} onCancelMove={onCancelMove} />
      </Stack>
    </ClientContent>
  );
}
